<button
    class="mb-8 shrink-0 rounded-full bg-surface-B p-4"
    interacta-icon-button
    type="button"
    [attr.aria-controls]="'notifications-panel'"
    [icon]="'close'"
    [label]="'SHARED.NOTIFICATIONS.CLOSE' | translate"
    [size]="'regular'"
    [style]="'text'"
></button>
<div
    #notificationPanel
    class="flex min-h-0 w-384 grow flex-col gap-y-12 rounded-2xl bg-surface-A px-12 pt-20"
    data-testid="notifications-panel"
>
    @let status = filterStatusMessage();
    <div aria-atomic="true" aria-live="polite" class="sr-only" role="status">
        @if (status) {
            {{ status.key | translate: status.params }}
        }
    </div>
    <div class="flex items-center justify-between">
        <h2 class="typo-t5" [attr.id]="titleId">
            {{ 'SHARED.NOTIFICATIONS.TITLE' | translate }}
        </h2>
        <interacta-toggle
            class="typo-sm"
            data-testid="notifications-unread-filter"
            [checked]="onlyUnread()"
            [label]="
                'SHARED.NOTIFICATIONS.SHOW_NOT_READ_FLAG'
                    | translate
                        : {
                              count: unreadNotificationsCount(),
                          }
            "
            [labelPosition]="'before'"
            (toggled)="setOnlyUnreadNotificationFilter(!onlyUnread())"
        />
    </div>
    @if (unreadNotificationsCount()) {
        <button
            class="ml-auto typo-sm text-text-primary"
            data-testid="notifications-mark-all-read"
            type="button"
            (click)="markAllAsRead()"
        >
            {{ 'SHARED.NOTIFICATIONS.MARK_ALL_AS_READ' | translate }}
        </button>
    }
    @let list = notifications().list;
    <interacta-invisible-scroll-v2
        [wheelScrollOnly]="true"
        (scrolled)="nextPage($event, notifications(), onlyUnread())"
    >
        <ul #listElement>
            @for (item of list; track item.id) {
                <li
                    class="flex flex-col gap-y-12 pb-12"
                    data-testid="notifications-item"
                    [attr.aria-setsize]="notifications().totalCount || -1"
                >
                    <interacta-notification-panel-item
                        [notification]="item"
                        (markAsRead)="markAsRead(item)"
                    />
                    @if (!$last) {
                        <interacta-separator [thickness]="'soft'" />
                    }
                </li>
            }
        </ul>
        @if (showLoadMore()) {
            <interacta-load-more
                class="py-8"
                [autoFocusLoader]="true"
                [isLoading]="notifications().isFetching"
                [label]="'UI.SHOW_MORE_UNCOUNT' | translate"
                [size]="'regular'"
                (loadMore)="
                    loadMorePastNotification(
                        notifications(),
                        onlyUnread(),
                        listElement
                    )
                "
            />
        }
    </interacta-invisible-scroll-v2>
    @if (showNoResult()) {
        <interacta-no-result
            [imageName]="'empty-page'"
            [subtitle]="
                (onlyUnread()
                    ? 'SHARED.NOTIFICATIONS.NO_UNREAD_NOTIFICATIONS'
                    : 'SHARED.NOTIFICATIONS.EMPTY_PAGE'
                ) | translate
            "
        />
    }
</div>
